import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import Select from '../../../common/components/input/control-suggest-select';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

const styles = theme => ({
	root:{
		width:'100%',
		paddingTop:10,
	},
	selectWrap:{
		width:300,
		marginTop:-12,
	},
	afterLabel:{
		padding: '0 15px',
		marginRight:100,
		lineHeight:'48px',
	},
});


class aggregateItem extends React.Component {
	
	constructor(props) {
		super(props);

		const aggregateValue = props.aggregateValue;
		let aggregateSelectValue = null;
		if(aggregateValue){
			const aggregateSelectValueArray = _.filter(props.aggregateSource, {'value' : aggregateValue});
			aggregateSelectValue = aggregateSelectValueArray.length ? aggregateSelectValueArray[0] : null;
		}

		this.state = {
			aggregatePropsValue : aggregateValue,
			aggregateSelectValue : aggregateSelectValue,
			orderValue : props.orderValue
		}
	}
	UNSAFE_componentWillReceiveProps(nextProps){
		if(this.state.aggregatePropsValue !== nextProps.aggregateValue){
			const aggregateSelectValueArray = _.filter(nextProps.aggregateSource, {'value' : nextProps.aggregateValue});
			const aggregateSelectValue = aggregateSelectValueArray.length ? aggregateSelectValueArray[0] : null;
			this.setState({
				aggregateSelectValue,
				aggregatePropsValue : nextProps.aggregateValue
			})
		}
		if(this.state.orderValue !== nextProps.orderValue){
			this.setState({
				orderValue : nextProps.orderValue
			})
		}
	}

	/** event handlers **/
	handleChangeSelect = (data) =>{
		if(this.props.afterChangeFunction) this.props.afterChangeFunction(this.props.dataIndex,"value",(data) ? data.value : null);
	};

	handleSortChange = (event) =>{
		if(this.props.afterChangeFunction) this.props.afterChangeFunction(this.props.dataIndex,"order",event.target.value);
	};



	render () {
		const { classes, dataIndex, aggregateSource, disabled} = this.props;
		const { aggregateSelectValue, orderValue} = this.state;

		const sortDisabled = (!(aggregateSelectValue) || disabled);

		return (
			<FormGroup className={classes.root} row>
				<div className={classes.selectWrap}>
					<Select
						inputLabel={"集計項目"+(dataIndex + 1)}
						suggestions={aggregateSource}
						value={aggregateSelectValue}
						maxMenuHeight={200}
						afterChangeFunction={this.handleChangeSelect}
						disabled={disabled}
					/>
				</div>
				<div className={classes.afterLabel}>
					別
				</div>
				<RadioGroup
					aria-label="gender"
					name="gender2"
					value={orderValue}
					onChange={this.handleSortChange}
					row
				>
					<FormControlLabel
						value="ASC"
						control={<Radio />}
						label="昇順"
						disabled={sortDisabled}

					/>
					<FormControlLabel
						value="DESC"
						control={<Radio />}
						label="降順"
						disabled={sortDisabled}
					/>
				</RadioGroup>
			</FormGroup>

		);
	}
}
aggregateItem.propTypes = {
	aggregateValue: PropTypes.string,
	orderValue:PropTypes.string,
	aggregateSource : PropTypes.array,
	dataIndex:PropTypes.number,
	afterChangeFunction : PropTypes.func,
	disabled:PropTypes.bool,
};
aggregateItem.defaultProps = {
	aggregateValue: null,
	orderValue:'ASC',
	aggregateSource : [],
	dataIndex:1,
	disabled:false,
};
export default withStyles(styles)(aggregateItem);



// WEBPACK FOOTER //
// ./src/routes/statistics/components/aggregate-item.js